import { localStorage } from 'lusha-widgets';

import { getFutureDateInDays, getTodayDate, twentyFourFormatDate } from '../date';

// eslint-disable-next-line import/named
import { MESSAGES_ELEMENT_FIELDS } from './constants';

export const setReappearanceDate = element => {
  const elementNextAppearance = MESSAGES_ELEMENT_FIELDS[element].nextAppearance;
  const elementDismissCount = MESSAGES_ELEMENT_FIELDS[element].dismissCount;

  const elementDismissTimes = localStorage.get(elementDismissCount, 1);
  const nextAppearanceInDays = elementDismissTimes > 2 ? 7 : 1;
  localStorage.set(elementNextAppearance, twentyFourFormatDate(getFutureDateInDays(nextAppearanceInDays)));
  localStorage.set(elementDismissCount, elementDismissTimes + 1);
};

export const shouldShowElement = element => {
  const elementNextAppearance = localStorage.get(MESSAGES_ELEMENT_FIELDS[element].nextAppearance, twentyFourFormatDate(getTodayDate()));

  return elementNextAppearance <= twentyFourFormatDate(getTodayDate());
};

